import { render, staticRenderFns } from "./IcoSignatureIdentity.vue?vue&type=template&id=2406f63f&scoped=true"
import script from "./IcoSignatureIdentity.vue?vue&type=script&lang=js"
export * from "./IcoSignatureIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406f63f",
  null
  
)

export default component.exports